import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  routesToCache: string[] = ["itemlist", "search"];
  storedRouteHandles = new Map<string, DetachedRouteHandle>();

  // Decides if the route should be stored
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    let detach = this.routesToCache.indexOf(route.data["key"]) > -1;
    // Logging removed (TA-008 / TR-009): intentional reuse strategy; warn was noise only.
    return detach;
  }

  //Store the information for the route we're destructing
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.storedRouteHandles.set(route.data["key"], handle);
  }

  //Return true if we have a stored route object for the next route
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.storedRouteHandles.has(route.data["key"]);
  }

  //If we returned true in shouldAttach(), now return the actual route data for restoration
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.storedRouteHandles.get(route.data["key"]);
  }

  // Reuse only when staying on the same routeConfig.
  // Angular API: shouldReuseRoute(future, curr). Legacy Angular 4 code had these
  // names swapped, which broke flush when returning List ← Search (STG expects reset).
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    let routeToFlush: ActivatedRouteSnapshot;
    if (curr.routeConfig != null) {
      // Flush list/search when navigating to them, unless coming back from CI detail (noflush).
      if (curr.data['key'] != 'noflush' && this.routesToCache.indexOf(future.data['key']) > -1) {
        routeToFlush = future;
      } else if (this.routesToCache.indexOf(curr.data['key']) > -1 && future.data['key'] != 'noflush') {
        routeToFlush = curr;
      }
      if (routeToFlush && routeToFlush.data['key'] && this.storedRouteHandles.has(routeToFlush.data['key'])) {
        this.storedRouteHandles.delete(routeToFlush.data['key']);
      }
    }

    return future.routeConfig === curr.routeConfig;
  }
}